import React, { Component } from 'react';
import { InputGroup, Button,Row,Col,Badge  } from 'reactstrap';
import PropTypes from 'prop-types';
import { BeatLoader } from 'react-spinners';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import api from '../../api/api.js';
import functions from '../../api/functions.js';
import format from "../../functions/functions.js";

import './styles.scss';

import stockFull from "../../assets/img/stock-full.png";
import stockMedium from "../../assets/img/stock-medium.png";
import stockLow from "../../assets/img/stock-low.png";
import stockNone from "../../assets/img/stock-none.png";
import superOferta from "../../assets/img/SuperOferta.png";

class ParadigmaSearch extends Component {
     constructor(props) {
          super(props);
          this.state = {
               redirectResultSearch:false,
               open: false,
               loading: false,
               loaded: false,
               recentQueries:[],
               productos: [],
               currentItemSelected:null,
               text: "",
               quantity:1,
          }
          this.dropdownHasFocus = false;
          this.timeoutWriting = null;
          this.timeoutFocus = null;
          this.searchInput = React.createRef();
          this.dropdownRef = React.createRef();
     }

     ImageStock = (data, code) => {
          let size = 24;
          switch(data) {
            case 'Bajo':
               return <img className="my-auto" alt="Stock Bajo" title="Stock Bajo" src={stockLow} height={size} width={size}/>
               break;
            case 'Medio':
              return <img className="my-auto" alt="Stock Medio" title="Stock Medio" src={stockMedium} height={size} width={size}/>
              break;
            case 'Alto':
              return <img className="my-auto" alt="Stock Alto" title="Stock Alto" src={stockFull} height={size} width={size}/>
              break;
            default:
               return <img className="my-auto" alt="Sin Stock" title="Sin Stock" src={stockNone} height={size} width={size}/>
               break;
          }
     }

     static propTypes = {
          placeholder: PropTypes.string,
          hyperlink: PropTypes.bool,
          autoselect: PropTypes.bool,
          addButton: PropTypes.bool,
          quantityInput: PropTypes.bool,
          showCode: PropTypes.bool,
          onSelectArticulo: PropTypes.func,
          onPressAddButton: PropTypes.func,
          router: PropTypes.object,
     }

     componentDidMount() {
          window.addEventListener("keydown", function(e) {
               if(
                    ([38, 40].indexOf(e.keyCode) > -1) &&
                    (String(document.activeElement.id).includes("recentQuery") || String(document.activeElement.id).includes("productList"))
               ) {
                    e.preventDefault();
               }
          }, false);
     }

     LoadRecentQueries(){
          functions.get(
               api.api.auth.recentqueries,
               null,
               1,
               null,
               (data) => {
                    if(data.meta.allowed){
                         let recentqueries = [];
                         data.data.recentqueries.filter(item=>item.trim() === item && item.trim() !== 'undefined').map(item => recentqueries.push(item));
                         this.setState(prevState => {
                              prevState.recentQueries = recentqueries.slice(0,10);
                              prevState.loading = false;
                              prevState.loaded = true;
                              return prevState;
                         });
                    }
               },
               ()=>{
                    this.setState(prevState => {
                         prevState.recentQueries = [];
                         prevState.loading = false;
                         prevState.loaded = true;
                         return prevState;
                    });
               }
          );
     }

     DestroyRecentQueries(){
          this.setState({recentQueries:[], currentItemSelected:null});
     }

     renderRecentQueries(){
          let {loaded, recentQueries} = this.state;
          this.dropdownHasFocus=true;
          return (
               loaded && recentQueries.length > 0 ?
               recentQueries.map(
                    (item, index) =>
                    <div className="dropdown-item"
                    onKeyDown={(e) => this.onKeyPress(e,item)}
                    onClick={ () => this.onChangeSearch(item)}
                    key={'recentQuery-'+String(index)}
                    id={'recentQuery-'+String(index)}
                    tabIndex={index}
                    >
                    <span>
                    {item}
                    </span>
                    </div>
               )
               :
               <div className="dropdown-item w-100" id={'recentQuery-empty'}>No existe historial de busqueda.</div>
          );
     }

     LoadProducts(text){
          if (text != undefined && text != null && text.trim() !== "" && text.length > 2) {
               const { autoselect, onSelectItem } = this.props;
               functions.get(
                    api.api.search,
                    null,
                    1,
                    {
                         'filters': ['query='+text],
                         'pageSize': 12,
                         'fields': ["Codigo", "link", "Titulo"]
                    },
                    (data) => {
                         this.setState(
                              prevState=>{
                                   if(data.data.productos){
                                        prevState.productos = data.data.productos;
                                        prevState.loading = false;
                                        prevState.loaded = true;
                                   }
                                   return prevState;
                              }
                         );
                    },
                    ()=>{
                         this.setState(prevState => {
                              prevState.productos = [];
                              prevState.loading = false;
                              prevState.loaded = true;
                              return prevState;
                         });
                    }
               );
          }
     }

     DestroyProducts(){
          this.setState({productos:[], currentItemSelected:null});
     }

     renderProducts(){
          let {loaded, productos} = this.state;
          this.dropdownHasFocus=true;
          return(
               loaded && productos.length > 0 ?
               productos.map(
                    (item, index) =>
                    <React.Fragment>
                    <a className="dropdown-item"
                    onClick={ (e) => this.setState({open:false})}
                    onKeyDown={(e) => this.onKeyPress(e,"")}
                    key={'productList-'+String(index)}
                    id={'productList-'+String(index)}
                    href={"#" + item.link}
                    >
                    {
                         item.PrecioSuperOferta > 0 &&
                         <span className="mr-1"><img src={superOferta} alt="Oferta Imagen" height="30" /></span>
                    }
                    <span className="my-auto d-block d-xs-block d-sm-none d-md-none d-lg-none d-xl-none">
                    {
                         item.Titulo.length > 22 ?
                         (
                              item.PrecioSuperOferta > 0 ?
                              item.Titulo.substring(0, 18) + "..."
                              :
                              item.Titulo.substring(0, 22) + "..."
                         )
                         :
                         item.Titulo
                    }
                    </span>
                    <span className="my-auto d-none d-xs-none d-sm-none d-md-block d-lg-block d-xl-block">{item.Titulo}</span>
                    <span className="position-absolute bg-white result__price">
                    {
                         item.PrecioSuperOferta > 0 ?
                         <span className="mr-1 my-auto">{` $${format.FormatPriceWithoutDecimals(item.PrecioSuperOferta)}`}</span>
                         :
                         <span className="mr-1 my-auto">{` $${format.FormatPriceWithoutDecimals(item.PrecioContado)}`}</span>
                    }
                    {this.ImageStock(item.disponibilidad, item.code)}
                    </span>
                    </a>
                    </React.Fragment>
               )
               :
               <div className="dropdown-item" id={'productList-empty'}>No existen coincidencias.</div>
          );
     }
     /* END PRODUCTS */

     setRedirectResultSearch(){
          if(this.state.text != undefined && this.state.text != null && this.state.text.length > 0){
               this.setState({
                    redirectResultSearch: true,
                    open:false,
                    loading:false,
                    loaded:false,
               });
          }
     }

     renderRedirectResultSearch(){

     }
     /* END REDIRECT */

     /* SearchBox */
     SearchBoxGotFocus() {
          let text = this.state.text;
          var field = document.createElement('input');
          this.setState({open:true, loading:true, loaded:false},
               ()=>{
                    let setTimeoutFocus = () => setTimeout(
                         ()=>{
                              let activeElement = document.activeElement;
                              if(activeElement.id != undefined){
                                   let id = String(activeElement.id);
                                   if (id == "searchbox" || id.includes("recentQuery") || id.includes("productList")) {
                                        clearTimeout(this.timeoutFocus);
                                        this.timeoutFocus = setTimeoutFocus();
                                   }
                                   else{
                                        this.setState({open:false, loading:false, loaded:false}, ()=>clearTimeout(this.timeoutFocus));
                                   }
                              }else{
                                   this.setState({open:false, loading:false, loaded:false}, ()=>clearTimeout(this.timeoutFocus));
                              }
                         },
                         250
                    );
                    if(this.timeoutFocus != undefined){
                         clearTimeout(this.timeoutFocus);
                    }
                    setTimeoutFocus();
                    if(text == undefined || text == null || text == "" || text.length == 0){
                         this.LoadRecentQueries();
                    }
                    else {
                         this.LoadProducts(text);
                    }
               }
          );
     }

     onChangeSearch = (value) => {
          this.setState(
               {text:value.trimStart()},
               ()=>{
                    if(this.timeoutWriting != undefined){
                         clearTimeout(this.timeoutWriting);
                    }
                    this.timeoutWriting = setTimeout(
                         ()=>{
                              let text = this.state.text;
                              if(text == undefined || text == null || text == "" || text.length == 0){
                                   this.LoadRecentQueries();
                              }
                              else {
                                   this.LoadProducts(text);
                              }
                         },
                         500
                    );
               }
          );
     }
     /* END SearchBox */

     onKeyPress(e,value) {
          let item = document.activeElement;
          let optionsContainer = this.dropdownRef.current.firstChild;
          switch (e.keyCode) {
               case 13: //enter
               if (item.id == "searchbox") { this.setRedirectResultSearch(); }
               if(String(item.id).includes("recentQuery") && value != undefined && value != ""){
                    this.setState(
                         {
                              text: value.trimStart(), recentQueries: [], productos:[], open: false, loaded: false, loading:false
                         },
                         ()=>{
                              document.querySelector('.main-search').focus();
                              this.LoadProducts(this.state.text);
                         }
                    );
               }
               break;
               case 27: //escape
               this.setState(
                    { currentItemSelected: null, text: "", quantity: 1, recentQueries: [], productos:[], loaded: false, loading:false},
                    ()=>{
                         if (item.id != "searchbox" && this.searchInput.current != undefined) { this.searchInput.current.focus(); }
                    }
               );
               break;
               case 38://up
               item = item.previousSibling;
               if (item == null) {
                    document.querySelector('.main-search').focus();
               } else {
                    item.focus();
               }
               break;
               case 40: //down
               if(item.id == "searchbox"){
                    let nextItem = optionsContainer.children.length > 0 ? optionsContainer.children[0]:undefined;
                    if(nextItem != undefined && this.state.loaded == true){
                         nextItem.focus();
                    }
                    else{
                         this.LoadRecentQueries();
                    }
               }
               else{
                    item = item.nextSibling;
                    item.focus();
               }
               break;
               default:
          }
     }

     CheckFocus(){

     }

     searchClick = (e) => {
          e.preventDefault();
          this.setRedirectResultSearch();
     }

     render() {
          const { text, open, loading, loaded } = this.state;
          const { placeholder, hyperlink, onSelectArticulo, addButton, quantityInput, showCode } = this.props;
          let textEmpty = text==undefined || text == null || text == "";
          if (this.state.redirectResultSearch) {
               let idTimeout = setTimeout(
                    ()=>{
                         this.setState(
                              {redirectResultSearch: false},
                              () => clearTimeout(idTimeout)
                         );
                         if (document.body.classList.contains('sidebar-show'))
                              document.body.classList.remove('sidebar-show');
                    }
                    , 10);
                    return <Redirect to={{pathname:'/ResultSearch/'+this.state.text, text:this.state.text}} />
               } else {
                    return (
                         <div className="mx-md-auto esige-search col-12 col-lg-6 mb-2"
                         onBlur={() => this.CheckFocus()}
                         >
                         <InputGroup>
                         <input
                         className="form-control main-search"
                         autoComplete="off"
                         id="searchbox"
                         ref={this.searchInput}
                         placeholder={placeholder ? placeholder : "¿Que estás búscando?"}
                         onFocus={() => this.SearchBoxGotFocus()}
                         onClick={() => this.SearchBoxGotFocus()}
                         onKeyDown={(e) => this.onKeyPress(e,"")}
                         onChange={(e) => this.onChangeSearch(e.target.value)}
                         value={text}
                         />

                         {/* <a href="#" title="Buscar" className="btn-search"
                         onClick={this.searchClick}
                         > &#x1F50D; </a> */}
                         <i className="fa fa-search btn-search" onClick={this.searchClick}></i>

                         <div className="dropdown ResultList"
                         ref={this.dropdownRef}
                         onBlur={()=>this.dropdownHasFocus=false}
                         >
                         <div className={"dropdown-menu " + (open && (loaded || loading) ? "show w-100" : "")}>
                         { loaded ?
                              (
                                   text == undefined || text == "" || text.length == 0 ?
                                   this.renderRecentQueries()
                                   :
                                   this.renderProducts()
                              )
                              : <div className="text-center w-100 mt-1"><BeatLoader /></div>
                         }
                         </div>
                         </div>
                         </InputGroup>
                         </div>
                    );
               }
          }
     }

     export default ParadigmaSearch;



// WEBPACK FOOTER //
// ./src/components/ParadigmaSearch/ParadigmaSearch.js